(function () {
    document.addEventListener('DOMContentLoaded', (event) => {
        var carousels = document.querySelectorAll('.header-carousel .siema-carousel .slides');
        var items = document.querySelectorAll('.header-carousel .siema-carousel .slides article');

        if (items.length > 1) {
            Array.prototype.forEach.call(carousels, function (el, i) {
                el.closest('.header-carousel').classList.add('header-carousel--active')

                // Has the carousel been automatically changed?
                let autoChange = false
                // The control button
                let control
                // The autoplay interval
                let autoplay
                // The next button
                let next

                const play = () => {
                    autoplay = setInterval(() => {
                        autoChange = true
                        next.click()
                    }, 5000)
                }

                var carousel = new Siema({
                    selector: carousels[i],
                    duration: 200,
                    easing: 'ease-out',
                    perPage: 1,
                    loop: true,
                    onInit: function () {
                        this.printCurrentSlide();
                        this.slideToCurrent();
                        this.addArrows();
                        this.showArrows();
                        this.addPagination();
                        this.updatePagination();

                        control = document.createElement('button')
                        control.classList.add('control')
                        control.setAttribute('aria-label', 'Play')
                        const pagination = el.closest('.siema-carousel').querySelector('.siema-pagination')
                        next = el.closest('.siema-carousel').querySelector('.siema-arrows button:last-child')

                        pagination.appendChild(control)

                        control.addEventListener('click', () => {
                            if (control.classList.contains('is-paused')) {
                                play()
                            } else {
                                clearInterval(autoplay)
                            }

                            control.classList.toggle('is-paused')
                        })

                        play()
                    },
                    onChange: function () {
                        this.printCurrentSlide();
                        this.updatePagination();

                        if (!autoChange) {
                            if (!control.classList.contains('is-paused')) {
                                clearInterval(autoplay)
                                play()
                            }
                        }

                        autoChange = false;
                    }
                });
            });
        }
    });
})();